import { hasRoleAdmin, hasRolePartner } from 'common/utility/userRoles';
import {
  UTILITY_ACTIVATION_ITEM_STATUS_ACCOUNT_REQUESTED,
  UTILITY_ACTIVATION_ITEM_STATUS_COMPLETED,
  UTILITY_ACTIVATION_ITEM_STATUS_DROPOUT,
} from 'common/utility/constants';

function isUtilityActivationFeedbackEligible(utilityUser, userUtilityActivation) {
  return Boolean(
    userUtilityActivation &&
    !hasRoleAdmin(utilityUser.roles) &&
    !userUtilityActivation.utilityActivationFeedbackId &&
    userUtilityActivation.items.every(
      ({ status }) =>
        status === UTILITY_ACTIVATION_ITEM_STATUS_COMPLETED ||
        status === UTILITY_ACTIVATION_ITEM_STATUS_ACCOUNT_REQUESTED ||
        status === UTILITY_ACTIVATION_ITEM_STATUS_DROPOUT,
    ),
  );
}

export default function shouldShowUtilityActivationFeedback(utilityUser, userUtilityActivation) {
  return isUtilityActivationFeedbackEligible(utilityUser, userUtilityActivation) &&
    !hasRolePartner(utilityUser.roles);
}

export function shouldSuppressUtilityActivationFeedback(utilityUser, userUtilityActivation) {
  return isUtilityActivationFeedbackEligible(utilityUser, userUtilityActivation) &&
    hasRolePartner(utilityUser.roles);
}
